<ion-content>
  <div class="warning-feature-banner" *ngIf="isSlackDisconnected">
    <ion-icon name="warning" class="padded-icon"></ion-icon>
    The Unthread app for Slack appears to be disconnected
    <ion-button
      color="dark"
      class="btn-small"
      routerLink="/dashboard/settings/slack"
      routerDirection="root"
    >
      <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
      Visit Slack settings to reinstall
    </ion-button>
  </div>

  <div class="constrained-content">
    <ion-grid>
      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="swap-horizontal-outline"></ion-icon>Triage Channel
          </h1>
          <p class="subtitle">
            Choose an internal channel to cross-post conversations to.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <app-channel-selector
                [channel]="triageChannel"
                (channelDidChange)="onTriageChannelChange($event)"
                [defaultInternalOnly]="true"
              ></app-channel-selector>
            </ion-card-content>
          </ion-card>
          <a
            href="https://docs.unthread.io/conversations/triaging"
            target="_blank"
            class="settings-learn-more"
          >
            <ion-icon name="book-outline"></ion-icon>
            Learn more about the triage channel
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="arrow-undo-circle-outline"></ion-icon>Auto-Responder
          </h1>
          <p class="subtitle">
            Automatically reply in a thread to new messages.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <app-autoresponder
              [isDefault]="true"
              [initialAutoresponder]="autoresponder"
              (autoresponderDidChange)="autoresponderDidChange($event)"
              [projectId]="undefined"
            ></app-autoresponder>
          </ion-card>
          <a
            href="https://docs.unthread.io/engagement/autoresponder"
            target="_blank"
            class="settings-learn-more"
          >
            <ion-icon name="book-outline"></ion-icon>
            Learn more about the auto-responder
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="albums-outline"></ion-icon>In-Channel Ticket Tracker
          </h1>
          <p class="subtitle">
            Add a pinned message to Slack where users can view and manage their
            support requests.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-list>
              <ion-item>
                <ion-label text-wrap>
                  <h3>
                    Enable In-Channel Ticket Tracker in all customer Slack
                    channels
                  </h3>
                </ion-label>
                <label class="switch" slot="end">
                  <input type="checkbox" [(ngModel)]="customerViewEnabled" />
                  <span class="slider"></span>
                </label>
              </ion-item>
              <ng-container *ngIf="customerViewEnabled">
                <ion-item>
                  <ion-label text-wrap>
                    <p>
                      <ion-icon name="checkmark"></ion-icon> Enabling this will
                      post a message to all customer channels with a button to
                      view requests
                    </p>
                    <p>
                      <ion-icon name="checkmark"></ion-icon> This message will
                      be pinned so it is easily accessible from the channel
                    </p>
                    <p>
                      <ion-icon name="checkmark"></ion-icon> You can also enable
                      this on a per-channel basis to try it out
                    </p>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-label text-wrap>
                    <h3>
                      Enable Private mode for Customer-Facing Ticket View in all
                      customer Slack channels
                    </h3>
                    <p>
                      New tickets will not be shared to the channel, and users
                      will only be able to see their own outstanding tickets.
                    </p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input
                      type="checkbox"
                      [(ngModel)]="customerViewSettings.isPrivate"
                    />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item *ngIf="customerViewSettings.isPrivate">
                  <ion-label text-wrap>
                    <p>
                      <ion-icon name="checkmark"></ion-icon> You can override
                      this setting on a per-customer basis
                    </p>
                  </ion-label>
                </ion-item>
                <ion-item *ngIf="customerViewSettings">
                  <ion-label text-wrap>
                    <h3>Pin to bottom</h3>
                    <p>
                      Pins the customer request tracker to the bottom of the
                      channel
                    </p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input
                      type="checkbox"
                      [(ngModel)]="customerViewSettings.isPinnedToBottom"
                    />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item
                  *ngIf="
                    customerViewSettings && !customerViewSettings.isPrivate
                  "
                >
                  <ion-label text-wrap>
                    <h3>Include count</h3>
                    <p>
                      Shows the number of open support requests in the pinned
                      message
                    </p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input
                      type="checkbox"
                      [(ngModel)]="customerViewSettings.includeCount"
                    />
                    <span class="slider"></span>
                  </label>
                </ion-item>
                <ion-item *ngIf="customerViewSettings">
                  <ion-label text-wrap>
                    <h3>Custom Message</h3>
                    <p>
                      Add custom text to appear in the pinned message (optional)
                    </p>
                  </ion-label>
                </ion-item>
                <div class="text-editor-container">
                  <app-slack-text-editor
                    [content]="customTokens['CUSTOMER_VIEW_CUSTOM_MESSAGE']"
                    placeholder="Your custom message here..."
                    style="width: 100%"
                    [hideStrikethrough]="true"
                    [hideCodeblock]="true"
                    [hideCode]="true"
                    [hideVariable]="true"
                    (contentDidChange)="onMessageContentChange($event)"
                    [projectId]="undefined"
                  >
                  </app-slack-text-editor>
                </div>
              </ng-container>
            </ion-list>
          </ion-card>
          <a
            href="https://docs.unthread.io/engagement/in-channel-ticket-tracker"
            target="_blank"
            class="settings-learn-more"
          >
            <ion-icon name="book-outline"></ion-icon>
            Learn more about the in-channel ticket tracker
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="calendar-outline"></ion-icon>Support Team &
            Scheduling
          </h1>
          <p class="subtitle">
            Set the appearance and working hours of your team.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-list>
              <ion-item class="no-padding">
                <strong>Support name & logo</strong>
              </ion-item>
            </ion-list>
            <div class="notification-preview">
              <div
                class="notification-icon"
                style="
                  width: 50px;
                  height: 50px;
                  border-radius: 8px;
                  border: 1px solid var(--input-border-color);
                "
              >
                <ion-button
                  slot="end"
                  size="full"
                  fill="clear"
                  (click)="uploadSupportLogo()"
                  class="icon-upload-button"
                >
                  <ion-icon
                    name="cloud-upload-outline"
                    [ngClass]="{ hide: !!supportLogo }"
                  ></ion-icon>
                </ion-button>
                <img *ngIf="supportLogo" [src]="supportLogo" />
              </div>
              <div>
                <ion-input
                  placeholder="Unthread"
                  [(ngModel)]="supportName"
                  class="select-outline"
                  style="margin-left: 5px; height: 50px; font-size: 1.1rem"
                >
                </ion-input>
              </div>
            </div>

            <ion-list>
              <ion-item>
                <ion-label>Support email address</ion-label>
                <ion-input
                  slot="end"
                  [(ngModel)]="email"
                  placeholder="support@piedpiper.com"
                ></ion-input>
              </ion-item>
              <ion-item>
                <ion-label
                  >Working hours ({{
                    workingHoursEnabled ? "enabled" : "disabled"
                  }})</ion-label
                >
                <ion-button
                  color="dark"
                  fill="clear"
                  class="button-dark-border"
                  (click)="manageWorkingHours()"
                >
                  Manage working hours
                </ion-button>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="person-circle-outline"></ion-icon>Custom User
            Attributes
          </h1>
          <p class="subtitle">
            Define custom fields to store additional information about users.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <app-custom-fields
              placeholder="Ex: Department"
              [customFields]="users.customProfileFields"
              [addCustomFieldButtonLabel]="'Add a custom user attribute'"
              [showPublicOption]="true"
              [showUserAttributeOption]="true"
              (didChange)="customUserFieldsDidChange()"
            >
            </app-custom-fields>
          </ion-card>
          <!-- TODO: Add learn more link if applicable -->
          <!-- <a href="https://docs.unthread.io/..." target="_blank" class="settings-learn-more">
            <ion-icon name="book-outline"></ion-icon>
            Learn more about custom user attributes
          </a> -->
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="chatbox-ellipses-outline"></ion-icon>Conversation
            Settings
          </h1>
          <p class="subtitle">
            Customize how conversation statuses are updated.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-title class="card-title">
              <h3>General Conversation Settings</h3>
            </ion-card-title>
            <ion-list>
              <ion-item>
                <ion-label>
                  <h3>
                    New replies move conversation status to "Needs response"
                  </h3>
                  <p>
                    Default behavior is to leave conversation as "In progress".
                  </p>
                </ion-label>
                <label class="switch" slot="end">
                  <input type="checkbox" [(ngModel)]="moveToNeedsResponse" />
                  <span class="slider"></span>
                </label>
              </ion-item>
              <ion-item>
                <ion-label text-wrap>
                  <h3>
                    Require "<code>/unthread send</code>" in Slack for external
                    replies
                  </h3>
                  <p>
                    If enabled, you will need to append
                    <code>/unthread send</code> to send replies via Email,
                    Teams, or In-app chat when replying from Slack (replying
                    from dashboard always sends by default). Messages without
                    <code>/unthread send</code> will be internal notes.
                  </p>
                </ion-label>
                <label class="switch" slot="end">
                  <input type="checkbox" [(ngModel)]="requireUnthreadSend" />
                  <span class="slider"></span>
                </label>
              </ion-item>
              <ion-item>
                <ion-label text-wrap>
                  <h3>Send post-close message</h3>
                  <p>Automatically send a message or survey after closing</p>
                  <ion-text color="warning"
                    >This feature is deprecated – we recommend using Automations
                    for post-close messages & surveys</ion-text
                  >
                </ion-label>
                <label class="switch" slot="end">
                  <input
                    type="checkbox"
                    [(ngModel)]="postCloseTemplateEnabled"
                  />
                  <span class="slider"></span>
                </label>
              </ion-item>
              <ng-container *ngIf="postCloseTemplateEnabled">
                <ion-item>
                  <ion-label slot="end">
                    Choose a template
                    <a
                      routerLink="/dashboard/outbound/templates"
                      routerDirection="root"
                      >(manage templates)</a
                    >
                  </ion-label>
                  <ion-label slot="end">
                    <ion-chip
                      mode="ios"
                      class="select-chip select-outline"
                      [outline]="true"
                      (click)="choosePostCloseTemplate()"
                    >
                      <ion-label>
                        {{
                          postCloseTemplateId ? postCloseTemplate?.name : "None"
                        }}
                        <ion-icon
                          name="caret-down-outline"
                          class="icon-padded-left"
                        ></ion-icon>
                      </ion-label>
                    </ion-chip>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-label slot="end" text-wrap>
                    Limit to ticket types:
                    <ion-chip
                      mode="ios"
                      color="primary"
                      class="btn-small tag-chip"
                      slot="end"
                      *ngFor="let ticket of postCloseTicketTypes; let i = index"
                      [title]="ticket.name"
                      (click)="removeTicketType(i)"
                    >
                      <ion-label>
                        {{ ticket.name }}
                        <ion-icon name="close-outline"></ion-icon>
                      </ion-label>
                    </ion-chip>
                  </ion-label>
                  <ion-button
                    class="btn-small"
                    fill="clear"
                    style="
                      --padding-start: 4px;
                      margin: 5px;
                      --padding-end: 4px;
                    "
                    slot="end"
                    (click)="addTicketType()"
                  >
                    <ion-label>
                      <ion-icon name="ticket"></ion-icon
                      ><ion-icon name="add-outline"></ion-icon>
                    </ion-label>
                  </ion-button>
                </ion-item>
                <ion-item>
                  <ion-label slot="end" text-wrap>
                    Limit to closed sub-statuses:
                    <ion-chip
                      mode="ios"
                      color="primary"
                      class="btn-small tag-chip"
                      slot="end"
                      *ngFor="
                        let subStatus of postCloseSubStatuses;
                        let i = index
                      "
                      [title]="subStatus.name"
                      (click)="removePostCloseSubStatus(i)"
                    >
                      <ion-label>
                        {{ subStatus.name }}
                        <ion-icon name="close-outline"></ion-icon>
                      </ion-label>
                    </ion-chip>
                  </ion-label>
                  <ion-button
                    class="btn-small"
                    fill="clear"
                    style="
                      --padding-start: 4px;
                      margin: 5px;
                      --padding-end: 4px;
                    "
                    slot="end"
                    (click)="addPostCloseSubStatus()"
                    [disabled]="!availableClosedSubStatuses?.length"
                  >
                    <ion-label>
                      <ion-icon name="filter"></ion-icon
                      ><ion-icon name="add-outline"></ion-icon>
                    </ion-label>
                  </ion-button>
                </ion-item>
                <ion-item>
                  <ion-label slot="end">
                    Send max once per conversation
                  </ion-label>
                  <ion-checkbox
                    style="margin: 5px"
                    slot="end"
                    [(ngModel)]="postCloseMaxOnce"
                  >
                  </ion-checkbox>
                </ion-item>
              </ng-container>
              <ion-item>
                <ion-label>
                  <h3>Default project</h3>
                </ion-label>
                <ion-chip
                  mode="ios"
                  class="select-chip select-outline"
                  [outline]="true"
                  (click)="setDefaultProject()"
                >
                  <ion-label>
                    {{ defaultProject?.name ?? "None" }}
                    <ion-icon
                      name="chevron-down-outline"
                      class="icon-padded-left"
                    ></ion-icon>
                  </ion-label>
                </ion-chip>
              </ion-item>
            </ion-list>
          </ion-card>

          <ion-card class="outline-card">
            <ion-card-title class="card-title">
              <h3>Stale Conversation Settings</h3>
              <div class="subtitle">
                Customize how stale conversations are handled
              </div>
            </ion-card-title>
            <ion-list>
              <ion-item>
                <ion-label>
                  <h3>Auto-close conversations</h3>
                  <p>Mark closed after a period of inactivity.</p>
                </ion-label>
                <ion-select
                  slot="end"
                  class="select-outline"
                  interface="popover"
                  [(ngModel)]="closeConversationsAfterHours"
                  [compareWith]="closeConversationsAfterHoursCompareFn"
                >
                  <ion-select-option [value]="null"
                    >Don't automatically close</ion-select-option
                  >
                  <ion-select-option
                    *ngFor="let option of conversationTimeoutOptions"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item *ngIf="closeConversationsAfterHours">
                <ion-label>
                  <h3>When to close inactive tickets</h3>
                </ion-label>
                <ion-select
                  slot="end"
                  class="select-outline"
                  interface="popover"
                  [(ngModel)]="closeStaleConversationsMode"
                >
                  <ion-select-option value="always">Always</ion-select-option>
                  <ion-select-option value="if-latest-message-is-internal">
                    If agent sent last message
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item>
                <ion-label>
                  <h3>Stale Intake Reminders</h3>
                  <p style="text-wrap: auto">
                    Remind users to close stale intakes explicitly after a
                    certain period of inactivity.
                  </p>
                </ion-label>
                <ion-select
                  class="select-outline"
                  interface="popover"
                  [(ngModel)]="sendRemindersForStaleIntakesAfterMinutes"
                  [compareWith]="
                    sendRemindersForStaleIntakesAfterMinutesCompareFn
                  "
                  style="min-width: 100px; width: auto"
                >
                  <ion-select-option [value]="null"
                    >Do not send reminders</ion-select-option
                  >
                  <ion-select-option
                    *ngFor="let option of staleIntakeReminderOptions"
                    [value]="option.value"
                    [disabled]="
                      closeConversationsAfterHours !== null &&
                      option.value / 60 >= closeConversationsAfterHours
                    "
                  >
                    {{ option.label }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-list>
          </ion-card>

          <ion-button
            expand="block"
            fill="clear"
            (click)="isShowingAdvanced = !isShowingAdvanced"
            style="margin: 20px 0"
          >
            <ion-icon
              [name]="
                isShowingAdvanced
                  ? 'chevron-up-outline'
                  : 'chevron-down-outline'
              "
              class="padded-icon"
            ></ion-icon>
            Show more advanced options
          </ion-button>
          <ion-card class="outline-card" *ngIf="isShowingAdvanced">
            <ion-card-header>
              <ion-card-title>
                <ion-label>Advanced configuration options</ion-label>
              </ion-card-title>
              <ion-card-subtitle>
                <ion-label
                  >You probably don't need to change these 😉</ion-label
                >
              </ion-card-subtitle>
            </ion-card-header>
            <ion-list>
              <ion-item>
                <ion-checkbox
                  [(ngModel)]="disableConversationsStartedByInternalUser"
                ></ion-checkbox>
                <ion-label>
                  <h3>
                    Do not create a conversation when a user replies to a thread
                    created by an agent
                  </h3>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-checkbox
                  [(ngModel)]="doNotReopenConversationsOnReply"
                ></ion-checkbox>
                <ion-label>
                  <h3>Do not re-open conversations when users reply</h3>
                  <p>Recommended: off</p>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-checkbox [(ngModel)]="autoSplittingEnabled"></ion-checkbox>
                <ion-label>
                  <h3>
                    Auto-split conversations when new threads are branched off
                    of a top-level message
                  </h3>
                  <p>Recommended: on</p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="pricetags-outline"></ion-icon>Priority Label
            Customization
          </h1>
          <p class="subtitle">
            Customize the display text for priority levels.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-list>
              <!-- LOW Priority Section -->
              <ion-item lines="none">
                <ion-label class="priority-section-label">
                  <ion-icon
                    [name]="getIconForPriority('LOW')"
                    class="padded-icon"
                  ></ion-icon>
                  <strong>Low Priority</strong>
                </ion-label>
              </ion-item>
              <ion-list style="padding-left: 20px">
                <div class="flexed-align-center">
                  <div
                    (click)="openPriorityEmojiPicker('LOW', $event)"
                    aria-label="Selected emoji for Low priority. Click to change."
                    slot="end"
                    class="emoji-picker-container"
                  >
                    <ng-container *ngIf="priorityLabelMapForm.LOW.EMOJI">
                      <img
                        *ngIf="
                          isURL(priorityLabelMapForm.LOW.EMOJI | colonToEmoji)
                        "
                        [src]="priorityLabelMapForm.LOW.EMOJI | colonToEmoji"
                        alt="Emoji"
                        class="action-icon"
                        class="emoji-image"
                      />
                      <span
                        *ngIf="
                          !isURL(priorityLabelMapForm.LOW.EMOJI | colonToEmoji)
                        "
                        class="action-icon"
                        >{{
                          priorityLabelMapForm.LOW.EMOJI | colonToEmoji
                        }}</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!priorityLabelMapForm.LOW.EMOJI">
                      <span>
                        {{
                          defaultPriorityLabelMap.LOW.EMOJI || "Select Emoji"
                        }}
                      </span>
                    </ng-container>
                    <button
                      *ngIf="priorityLabelMapForm.LOW.EMOJI"
                      (click)="
                        priorityLabelMapForm.LOW.EMOJI = null;
                        $event.stopPropagation()
                      "
                      class="clear-button"
                    >
                      <ion-icon name="close-outline"></ion-icon>
                    </button>
                  </div>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.LOW.LABEL"
                    [placeholder]="defaultPriorityLabelMap.LOW.LABEL"
                    slot="end"
                  ></ion-input>
                </div>
                <ion-item>
                  <ion-label>Description</ion-label>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.LOW.DESCRIPTION"
                    [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.LOW"
                    slot="end"
                  ></ion-input>
                </ion-item>
              </ion-list>

              <!-- MEDIUM Priority Section -->
              <ion-item lines="none">
                <ion-label class="priority-section-label">
                  <ion-icon
                    [name]="getIconForPriority('MEDIUM')"
                    class="padded-icon"
                  ></ion-icon>
                  <strong>Medium Priority</strong>
                </ion-label>
              </ion-item>
              <ion-list style="padding-left: 20px">
                <div class="flexed-align-center">
                  <div
                    (click)="openPriorityEmojiPicker('MEDIUM', $event)"
                    aria-label="Selected emoji for Medium priority. Click to change."
                    slot="end"
                    class="emoji-picker-container"
                  >
                    <ng-container *ngIf="priorityLabelMapForm.MEDIUM.EMOJI">
                      <img
                        *ngIf="
                          isURL(
                            priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji
                          )
                        "
                        [src]="priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji"
                        alt="Emoji"
                        class="action-icon"
                        class="emoji-image"
                      />
                      <span
                        *ngIf="
                          !isURL(
                            priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji
                          )
                        "
                        class="action-icon"
                        >{{
                          priorityLabelMapForm.MEDIUM.EMOJI | colonToEmoji
                        }}</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!priorityLabelMapForm.MEDIUM.EMOJI">
                      <span>
                        {{
                          defaultPriorityLabelMap.MEDIUM.EMOJI || "Select Emoji"
                        }}
                      </span>
                    </ng-container>
                    <button
                      *ngIf="priorityLabelMapForm.MEDIUM.EMOJI"
                      (click)="
                        priorityLabelMapForm.MEDIUM.EMOJI = null;
                        $event.stopPropagation()
                      "
                      class="clear-button"
                    >
                      <ion-icon name="close-outline"></ion-icon>
                    </button>
                  </div>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.MEDIUM.LABEL"
                    [placeholder]="defaultPriorityLabelMap.MEDIUM.LABEL"
                    slot="end"
                  ></ion-input>
                </div>
                <ion-item>
                  <ion-label>Description</ion-label>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.MEDIUM.DESCRIPTION"
                    [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.MEDIUM"
                    slot="end"
                  ></ion-input>
                </ion-item>
              </ion-list>

              <!-- HIGH Priority Section -->
              <ion-item lines="none">
                <ion-label class="priority-section-label">
                  <ion-icon
                    [name]="getIconForPriority('HIGH')"
                    class="padded-icon"
                  ></ion-icon>
                  <strong>High Priority</strong>
                </ion-label>
              </ion-item>
              <ion-list style="padding-left: 20px">
                <div class="flexed-align-center">
                  <div
                    (click)="openPriorityEmojiPicker('HIGH', $event)"
                    aria-label="Selected emoji for High priority. Click to change."
                    slot="end"
                    class="emoji-picker-container"
                  >
                    <ng-container *ngIf="priorityLabelMapForm.HIGH.EMOJI">
                      <img
                        *ngIf="
                          isURL(priorityLabelMapForm.HIGH.EMOJI | colonToEmoji)
                        "
                        [src]="priorityLabelMapForm.HIGH.EMOJI | colonToEmoji"
                        alt="Emoji"
                        class="action-icon"
                        class="emoji-image"
                      />
                      <span
                        *ngIf="
                          !isURL(priorityLabelMapForm.HIGH.EMOJI | colonToEmoji)
                        "
                        class="action-icon"
                        >{{
                          priorityLabelMapForm.HIGH.EMOJI | colonToEmoji
                        }}</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!priorityLabelMapForm.HIGH.EMOJI">
                      <span>
                        {{
                          defaultPriorityLabelMap.HIGH.EMOJI || "Select Emoji"
                        }}
                      </span>
                    </ng-container>
                    <button
                      *ngIf="priorityLabelMapForm.HIGH.EMOJI"
                      (click)="
                        priorityLabelMapForm.HIGH.EMOJI = null;
                        $event.stopPropagation()
                      "
                      class="clear-button"
                    >
                      <ion-icon name="close-outline"></ion-icon>
                    </button>
                  </div>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.HIGH.LABEL"
                    [placeholder]="defaultPriorityLabelMap.HIGH.LABEL"
                    slot="end"
                  ></ion-input>
                </div>
                <ion-item>
                  <ion-label>Description</ion-label>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.HIGH.DESCRIPTION"
                    [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.HIGH"
                    slot="end"
                  ></ion-input>
                </ion-item>
              </ion-list>

              <!-- CRITICAL Priority Section -->
              <ion-item lines="none">
                <ion-label class="priority-section-label">
                  <ion-icon
                    [name]="getIconForPriority('CRITICAL')"
                    class="padded-icon"
                  ></ion-icon>
                  <strong>Critical Priority</strong>
                </ion-label>
              </ion-item>
              <ion-list style="padding-left: 20px">
                <div class="flexed-align-center">
                  <div
                    (click)="openPriorityEmojiPicker('CRITICAL', $event)"
                    aria-label="Selected emoji for Critical priority. Click to change."
                    slot="end"
                    class="emoji-picker-container"
                  >
                    <ng-container *ngIf="priorityLabelMapForm.CRITICAL.EMOJI">
                      <img
                        *ngIf="
                          isURL(
                            priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                          )
                        "
                        [src]="
                          priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                        "
                        alt="Emoji"
                        class="action-icon"
                        class="emoji-image"
                      />
                      <span
                        *ngIf="
                          !isURL(
                            priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                          )
                        "
                        class="action-icon"
                        >{{
                          priorityLabelMapForm.CRITICAL.EMOJI | colonToEmoji
                        }}</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!priorityLabelMapForm.CRITICAL.EMOJI">
                      <span>
                        {{
                          defaultPriorityLabelMap.CRITICAL.EMOJI ||
                            "Select Emoji"
                        }}
                      </span>
                    </ng-container>
                    <button
                      *ngIf="priorityLabelMapForm.CRITICAL.EMOJI"
                      (click)="
                        priorityLabelMapForm.CRITICAL.EMOJI = null;
                        $event.stopPropagation()
                      "
                      class="clear-button"
                    >
                      <ion-icon name="close-outline"></ion-icon>
                    </button>
                  </div>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.CRITICAL.LABEL"
                    [placeholder]="defaultPriorityLabelMap.CRITICAL.LABEL"
                    slot="end"
                  ></ion-input>
                </div>
                <ion-item>
                  <ion-label>Description</ion-label>
                  <ion-input
                    [(ngModel)]="priorityLabelMapForm.CRITICAL.DESCRIPTION"
                    [placeholder]="FORM_PLACEHOLDER_DESCRIPTIONS.CRITICAL"
                    slot="end"
                  ></ion-input>
                </ion-item>
              </ion-list>
            </ion-list>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar class="constrained-content">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-md="5"> </ion-col>
        <ion-col size="12" size-md="7">
          <ion-button color="success" (click)="save()"
            >Save changes
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
